import React from 'react';
import { Tooltip } from 'antd';
import useTranslation from '../../../hooks/translation/useTranslation';
import { ReactComponent as Exit } from '../../../../resources/images/wagon-icons/exit.svg';
import { ReactComponent as Toilet } from '../../../../resources/images/wagon-icons/toilet.svg';
import { ReactComponent as ElectricCabin } from '../../../../resources/images/wagon-icons/electricCabin.svg';
import Seat from '../../components/Seat';

function Wagon({
  seatColumns,
  topSeatColumns,
  seats,
  chosenSeats,
  setChosenSeats,
  wagonNumber,
  reserveSeat,
  unReserveSeat,
  bottomFixed,
}) {
  const { trans } = useTranslation();

  return (
    <div>
      <div className="wagon flex flex-col justify-between items-center">
        <div className="wagon-floor">
          <h2>I</h2>
        </div>
        <div
          className="wagon-feature mxp absolute top-[40%] right-[15px]"
        >
          <Tooltip title={trans('wagon_exit')}>
            <Exit />
          </Tooltip>
        </div>
        <div
          className="flex justify-between w-[84%]"
        >
          <div className="flex gap-x-2">
            <Tooltip title={trans('toilet')}>
              <Toilet />
            </Tooltip>
            <Tooltip title={trans('toilet')}>
              <Toilet />
            </Tooltip>
          </div>
          {topSeatColumns && topSeatColumns.map((column, columnIndex) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={columnIndex} className="seat-column">
              {column.map((seatIndex) => (
                <Seat
                  key={seatIndex}
                  seat={seats?.[seatIndex]}
                  chosenSeats={chosenSeats}
                  setChosenSeats={setChosenSeats}
                  wagonNumber={wagonNumber}
                  reserveSeat={reserveSeat}
                  unReserveSeat={unReserveSeat}
                  noDirection
                  bottom
                />
              ))}
            </div>
          ))}
          <div className="flex gap-x-2 ml-2.5">
            <Tooltip title={trans('toilet')}>
              <Toilet />
            </Tooltip>
            <Tooltip title={trans('toilet')}>
              <Toilet />
            </Tooltip>
          </div>
        </div>

        <div
          className="flex gap-x-2"
        >
          <div
            className="wagon-feature mr-2.5 ml-5 flex items-center"
          >
            <div className="flex gap-x-2">
              <Tooltip title={trans('toilet')}>
                <Toilet />
              </Tooltip>
              <Tooltip title={trans('toilet')}>
                <Toilet />
              </Tooltip>
            </div>
            {seatColumns.map((column, columnIndex) => (
              // eslint-disable-next-line react/no-array-index-key
              <div key={columnIndex} className="seat-column">
                {column.map((seatIndex) => (
                  <Seat
                    key={seatIndex}
                    seat={seats?.[seatIndex]}
                    chosenSeats={chosenSeats}
                    setChosenSeats={setChosenSeats}
                    wagonNumber={wagonNumber}
                    reserveSeat={reserveSeat}
                    unReserveSeat={unReserveSeat}
                    noDirection
                    bottom={bottomFixed ? true : seatIndex % 2 === 1}
                  />
                ))}
              </div>
            ))}
            <div className="flex gap-x-2 ml-2.5">
              <Tooltip title="Купе проводника">
                <Toilet />
              </Tooltip>
              <Tooltip title="Электрокупе">
                <ElectricCabin />
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
}

export default Wagon;
